import { render, staticRenderFns } from "./EditProfileComponent.vue?vue&type=template&id=1bc09861&"
import script from "./EditProfileComponent.vue?vue&type=script&lang=js&"
export * from "./EditProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports